import React from 'react';
import { Check, CheckCircle } from 'lucide-react';
export function FeaturesSection() {
  return <section className="py-20 bg-white" data-id="element-97">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-98">
        <div className="text-center mb-16" data-id="element-99">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1E3A5F] mb-4" data-id="element-100">
            QUÉ TE LLEVÁS HOY
          </h2>
          <div className="w-24 h-1.5 bg-[#F59E0B] mx-auto rounded-full" data-id="element-101"></div>
        </div>

        <div className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-12 shadow-xl mb-16 relative overflow-hidden" data-id="element-102">
          <div className="absolute top-0 right-0 bg-[#1E3A5F] text-white px-6 py-2 rounded-bl-2xl font-bold" data-id="element-103">
            BASE
          </div>

          <h3 className="text-3xl font-bold text-[#1E3A5F] mb-6" data-id="element-104">
            MEGA PACK APRENDIZAJE LECTURA™
          </h3>

          <p className="text-xl font-semibold text-[#16A34A] mb-8" data-id="element-105">
            192 lecturas narrativas + 192 fichas de actividades para todo el año
          </p>

          <div className="mb-10" data-id="element-106">
            <h4 className="text-lg font-bold text-slate-800 mb-4 uppercase tracking-wide" data-id="element-107">
              Cada semana incluye:
            </h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-108">
              {['Texto narrativo de 10 renglones adaptado al nivel del grado', 'Preguntas de comprensión lectora', 'Actividades de reflexión personal', 'Espacio de producción escrita', 'Progresión pedagógica de marzo a diciembre'].map((item, i) => <li key={i} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-slate-100" data-id="element-109">
                  <Check className="w-6 h-6 text-[#F59E0B] mr-3 flex-shrink-0" data-id="element-110" />
                  <span className="text-slate-700 font-medium" data-id="element-111">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm" data-id="element-112">
            <table className="w-full text-left border-collapse" data-id="element-113">
              <thead data-id="element-114">
                <tr className="bg-[#1E3A5F] text-white" data-id="element-115">
                  <th className="p-4 font-bold text-lg w-1/3" data-id="element-116">Grado</th>
                  <th className="p-4 font-bold text-lg" data-id="element-117">Foco del Año</th>
                </tr>
              </thead>
              <tbody className="bg-white" data-id="element-118">
                <tr className="border-b border-slate-100 hover:bg-slate-50" data-id="element-119">
                  <td className="p-4 font-bold text-slate-800" data-id="element-120">1º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-121">
                    Reconocimiento de letras y fluidez básica
                  </td>
                </tr>
                <tr className="border-b border-slate-100 hover:bg-slate-50 bg-slate-50/50" data-id="element-122">
                  <td className="p-4 font-bold text-slate-800" data-id="element-123">2º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-124">
                    Comprensión de tramas y vocabulario
                  </td>
                </tr>
                <tr className="border-b border-slate-100 hover:bg-slate-50" data-id="element-125">
                  <td className="p-4 font-bold text-slate-800" data-id="element-126">3º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-127">
                    Comprensión inferencial e inicio de análisis
                  </td>
                </tr>
                <tr className="border-b border-slate-100 hover:bg-slate-50 bg-slate-50/50" data-id="element-128">
                  <td className="p-4 font-bold text-slate-800" data-id="element-129">4º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-130">
                    Textos expositivos, leyendas y noticias
                  </td>
                </tr>
                <tr className="border-b border-slate-100 hover:bg-slate-50" data-id="element-131">
                  <td className="p-4 font-bold text-slate-800" data-id="element-132">5º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-133">
                    Argumentación y reflexión ciudadana
                  </td>
                </tr>
                <tr className="hover:bg-slate-50 bg-slate-50/50" data-id="element-134">
                  <td className="p-4 font-bold text-slate-800" data-id="element-135">6º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-136">
                    Pensamiento crítico y análisis profundo
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-137">
          <div className="flex items-center bg-green-50 px-6 py-3 rounded-full border border-green-200" data-id="element-138">
            <CheckCircle className="w-6 h-6 text-[#16A34A] mr-2" data-id="element-139" />
            <span className="font-bold text-green-800" data-id="element-140">
              Escuela pública y privada
            </span>
          </div>
          <div className="flex items-center bg-green-50 px-6 py-3 rounded-full border border-green-200" data-id="element-141">
            <CheckCircle className="w-6 h-6 text-[#16A34A] mr-2" data-id="element-142" />
            <span className="font-bold text-green-800" data-id="element-143">
              Turno mañana y tarde
            </span>
          </div>
          <div className="flex items-center bg-green-50 px-6 py-3 rounded-full border border-green-200" data-id="element-144">
            <CheckCircle className="w-6 h-6 text-[#16A34A] mr-2" data-id="element-145" />
            <span className="font-bold text-green-800" data-id="element-146">
              Impresión o proyección
            </span>
          </div>
        </div>
      </div>
    </section>;
}